// @flow
import React from 'react';
import ProfileAllProductPins from 'app/common/react/components/profile/storefront/ProfileProductPins/ProfileAllProductPins';
import ProfileProductGroups from 'app/common/react/components/profile/storefront/ProfileProductGroups/ProfileProductGroups';
import ProfileProductPins from 'app/common/react/components/profile/storefront/ProfileProductPins/ProfileProductPins';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import withRouteData from 'app/common/lib/react/withRouteData';
import { Box } from 'gestalt';
import { compose } from 'redux';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import withResource, { type Resource } from 'app/common/lib/react/withResource';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

const PRODUCT_GROUP_DATA_TYPE = 'productgroup';

type Props = {|
  params: {| username: string |},
  requestContext: RequestContextType,
  storeFrontAllProductsResource: Resource<Array<Object>>,
  storeFrontResource: Resource<Array<Object>>,
  userResource: Resource<ProfileUser>,
  viewer: Viewer,
|};

class ProfileProductGroupsContainer extends React.PureComponent<Props> {
  scrollContainer: ?HTMLElement;

  render() {
    const {
      params,
      requestContext,
      storeFrontResource,
      storeFrontAllProductsResource,
      userResource,
      viewer,
    } = this.props;

    if (
      !userResource ||
      !userResource.data ||
      !storeFrontResource ||
      !storeFrontResource.data ||
      !storeFrontAllProductsResource ||
      !storeFrontAllProductsResource.data ||
      !Array.isArray(storeFrontResource.data) ||
      !Array.isArray(storeFrontAllProductsResource.data) ||
      !(
        userResource.data.has_catalog &&
        ((viewer.isAuth && viewer.username === userResource.data.username) ||
          new SingleTreatmentExp(requestContext, 'bizpro_web_tur_bazzar').enabled())
      )
    ) {
      return null;
    }

    const isProductGroup =
      storeFrontResource.data.length > 0 &&
      storeFrontResource.data[0].type === PRODUCT_GROUP_DATA_TYPE;

    const isOwnProfile = viewer.isAuth && viewer.username === params.username;

    return (
      <React.Fragment>
        {isProductGroup && (
          <Box ref={(ref) => (this.scrollContainer = ref)}>
            <ProfileProductGroups
              isOwnProfile={isOwnProfile}
              productGroups={storeFrontResource.data}
              username={userResource.data.username}
              scrollContainer={() => this.scrollContainer || window}
            />
          </Box>
        )}
        {!isProductGroup &&
          storeFrontResource.data.length > 0 && (
            <ProfileProductPins
              isOwnProfile={isOwnProfile}
              pins={storeFrontResource}
              user={userResource.data}
              isGridCentered
            />
          )}
        {storeFrontAllProductsResource.data.length > 0 && (
          <Box paddingY={3}>
            <ProfileAllProductPins
              isOwnProfile={isOwnProfile}
              allProductPins={storeFrontAllProductsResource}
              user={userResource.data}
            />
          </Box>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withViewer,
  withResource({
    name: 'UserResource',
    key: 'userResource',
    options: ({ params }) => ({
      username: params.username,
      field_set_key: 'profile',
    }),
  }),
  withRouteData({
    name: 'ProfileProductGroups',
    routeContextLog: (context: Object, params: { username: string }) => {
      let userId;
      if ((context.user || {}).username === params.username) {
        userId = (context.user || {}).id;
      }
      return {
        object_id_str: userId,
        view_type: PCONST.thrift.ViewType.USER,
        view_parameter: PCONST.thrift.ViewParameterType.USER_STOREFRONT,
      };
    },
  }),
  withResource({
    name: 'StoreFrontFeedResource',
    key: 'storeFrontResource',
    options: ({ params, viewer, userResource }) => ({
      username: params.username,
      userId: userResource && userResource.data ? userResource.data.id : undefined,
      field_set_key: 'grid_item',
    }),
  }),
  withResource({
    name: 'StoreFrontFeedResource',
    key: 'storeFrontAllProductsResource',
    options: ({ params, viewer, userResource }) => ({
      username: params.username,
      userId: userResource && userResource.data ? userResource.data.id : undefined,
      field_set_key: 'grid_item',
      product_group_type: 'ALL_PRODUCTS',
    }),
  }),
  withRequestContext,
)(ProfileProductGroupsContainer);
